<template>
    <div :class="'road-card road-card--'+status">
        <p class="name">{{ name }}</p>
        <p v-if="value!=undefined" class="value">{{ value }}</p>
        <img v-else-if="img" :src="img" alt="">
    </div>
</template>

<script>
export default {
    data: function () {
        return {

        }
    },
    props: {
        name: String,
        value: String,
        img: String,
        status: String
    }
}
</script>
<style lang="scss">
.road-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid;
    border-radius: 10px;
    height: 75px;
    border-left: 12px solid;
    background: var(--v-cardBackground-base);
    border-color: #9A9A9A;
    padding: 17px;
    .name{
        font-size: 14px;
        margin-bottom: 0;
    }
    .value{
        font-size: 32px;
        font-weight: bold;
        margin-bottom: 0;
    }
    &.road-card--success{
        border-color: var(--v-darkGreen-base);
    }
    img{
        width: 100px;
        background: var(--v-cardBackgroundForLogo-base);
        padding: 20px;
        border-radius: 10px;
    }
}
</style>